/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useRef, useState } from 'react';
import { useQuery } from 'react-query';
import { Button, Space, Popconfirm, Row, Col, Tooltip, Modal } from 'antd';
import { CaretDownOutlined, CaretUpOutlined, EditOutlined, DeleteOutlined, DownloadOutlined, FileTextOutlined, EyeOutlined, SaveOutlined, LeftOutlined } from '@ant-design/icons';

import { get, remove } from 'helpers/QueryHelper';

import withAuthenticator from 'HOCs/withAuthenticator';
import DynamicTable from 'packages/DynamicForm/components/DynamicTable';
import colors from 'constants/colors';
import TeacherContainer from 'components/Containers/TeacherContainer';
import CanvasToolPage from 'modules/TestingModule/CanvasToolPlus/CanvasToolPage';
import notificationWithIcon from 'components/Notification/notificationWithIcon';
import ExcercisePage from 'modules/TestingModule/CanvasToolPlus/ExcercisePage';
import ExerciseForStudent from 'modules/AssignmentsManagement/components/Modal/ExerciseForStudent';
import Footer, { footerKey } from 'modules/TestingModule/CanvasToolPlus/ExcercisePage/Footer';
import tableData from './tableData';
import FolderTreeView from './components/FolderTreeView';
import UploadFiles from './components/UploadFiles';
import ListClasses from './components/ListClasses';
import ListSubjects from './components/ListSubjects';
import ListUnits from './components/ListUnits';

const fetcher = (folderId) => () => {
  if (!folderId) return [];
  return get('Attachments', '*', { entityId: folderId, entityName: 't_SACHSO_CLASSES_Folders' }, 'CreatedDate DESC', 'SHARE');
};

const Folders = ({ classId, loggedInUser }) => {
  const isTeacherRole = loggedInUser.role === 'teacher';
  const [refresh, setRefresh] = React.useState(new Date());
  const [selectedFolderId, setSelectedFolderId] = React.useState(null);
  const [expandedRowKeys, setExpandedRowKeys] = React.useState([]);
  const [worksheetFile, setWorksheetFile] = React.useState(null);
  const canvasRef = React.useRef({});

  const key = ['t_SACHSO_SHARE_Attachments', selectedFolderId, refresh];
  const { data, isLoading } = useQuery(key, fetcher(selectedFolderId));

  const [modalVisible, setModalVisible] = React.useState(false);

  const [exerciseModalVisible, setExerciseModalVisible] = React.useState(false);
  const [fileType, setFileType] = React.useState('worksheet');

  const [progressModalVisible, setProgressModalVisible] = React.useState(false);
  const [openClassesOrSubjects, setOpenClassesOrSubjects] = React.useState(false);

  const [classFields, setClassFelds] = React.useState(null);

  const handleMoveToSubjects = (classs) => {
    setOpenClassesOrSubjects(true);
    setClassFelds(classs);
  };
  const handleMoveToClasses = () => setOpenClassesOrSubjects(false);

  // GIÁO VIÊN xem trước bài tập sẽ giao.
  const [previewExercise, setPreviewExercise] = useState(false);
  const [file, setFile] = React.useState(null);
  // Dùng trong Preview Exercise Modal.
  const refSubmit = useRef({});
  // Dùng trong Progress Modal.
  const [openListTopics, setOpenListTopics] = useState(false); // Chuyển đổi state ListUnits và ListTopics
  const [numberUnit, setNumberUnit] = useState(0);
  const handleChangeTitle = (classesOrUnits) => {
    if (classesOrUnits) {
      return openListTopics ? `Đề kiểm tra Unit ${numberUnit}` : 'Bài tập theo Unit';
    }
    return 'Danh sách lớp quản lý';
  };

  const [footerMode, setFooterMode] = useState('');
  const [idCurrent, setidCurrent] = useState('');
  const openEditor = React.useCallback((id, delay = 0) => {
    setTimeout(() => {
      setidCurrent(id);
      setFileType('worksheet');
      setFooterMode(id ? footerKey.EDIT : footerKey.CREATE); // id==='' => CREATE
      setModalVisible(true);
    }, delay);
  }, []);

  return (
    <div>
      <Row gutter={[12, 0]}>
        <Col span={24} lg={6}>
          <div style={{ border: 'dashed 1px', borderColor: colors.border, padding: 12, minHeight: 400 }} className='rounded'>
            <FolderTreeView
              classId={classId}
              onSelect={(folder) => {
                setSelectedFolderId(folder.id);
              }}
            />
          </div>
        </Col>
        <Col span={24} lg={18}>
          <div style={{ border: 'dashed 1px', borderColor: colors.border, padding: 12, minHeight: 400 }} className='rounded'>
            <TeacherContainer>
              {selectedFolderId && (
                <Row gutter={[16, 16]}>
                  <Col>
                    <UploadFiles
                      folderId={selectedFolderId}
                      onSuccess={() => {
                        setRefresh(new Date());
                      }}
                    />
                  </Col>
                  <Col>
                    <Button
                      type='primary'
                      onClick={() => {
                        openEditor('');
                      }}
                    >
                      Tạo bài tập chấm tự động
                    </Button>
                  </Col>
                  <Col>
                    <Button
                      type='primary'
                      onClick={() => {
                        setProgressModalVisible(true);
                      }}
                    >
                      Đề kiểm tra tiến độ
                    </Button>
                  </Col>
                </Row>
              )}
            </TeacherContainer>
            <DynamicTable
              loading={isLoading}
              dataSource={data}
              initialTableData={tableData}
              expandable={{
                expandIconColumnIndex: 999,
                expandedRowKeys,
                columnWidth: '1%',
                expandIcon: ({ expanded, onExpand, record }) => (expanded ? <CaretUpOutlined onClick={(e) => onExpand(record, e)} /> : <CaretDownOutlined onClick={(e) => onExpand(record, e)} />),
                expandRowByClick: true,
                onExpand: (expanded, record) => {
                  const keys = [];
                  if (expanded) {
                    keys.push(record.id);
                  }
                  setExpandedRowKeys(keys);
                },

                expandedRowRender: ({ id, fileName, fileUrl, tags, jsonData }) => (
                  <div style={{}} className='d-flex'>
                    <div style={{ flex: 1, display: 'flex', justifyContent: 'flex-start' }}>
                      <div className='ml-2'>
                        <Tooltip title='Xem trước bài tập' placement='bottom'>
                          <Button
                            key='download-file'
                            type='primary'
                            icon={<EyeOutlined />}
                            onClick={() => {
                              if (tags === 'LIVEWORKSHEET') {
                                setPreviewExercise(true);
                                setFile({ id, fileName, jsonData });
                              } else {
                                notificationWithIcon('warning', 'Thông báo', 'Tập tin này không thể xem trước !');
                              }
                            }}
                          >
                            Xem trước
                          </Button>
                        </Tooltip>
                      </div>
                      <div className='ml-2'>
                        <Tooltip title='Giao bài' placement='bottom'>
                          <Button
                            onClick={() => {
                              setExerciseModalVisible(true);
                              // if (tags === 'LIVEWORKSHEET') {
                              //   setWorksheetFile({ id, imgURL: `https://cloud.softech.vn${fileUrl}`, jsonData });
                              // }
                              setWorksheetFile({ id, imgURL: `https://cloud.softech.vn${fileUrl}`, tags });
                            }}
                            key='Assignment'
                            type='primary'
                            icon={<FileTextOutlined />}
                          >
                            Giao bài
                          </Button>
                        </Tooltip>
                      </div>
                    </div>

                    <TeacherContainer>
                      <div style={{ flex: 0, display: 'flex', justifyContent: 'flex-end' }}>
                        <Space>
                          <Tooltip title='Chỉnh sửa' placement='bottom'>
                            <Button
                              key='move-file'
                              shape='circle'
                              type='dashed'
                              icon={<EditOutlined />}
                              onClick={() => {
                                if (tags === 'LIVEWORKSHEET') {
                                  openEditor(id);
                                  setWorksheetFile({ id, imgURL: `https://cloud.softech.vn${fileUrl}`, jsonData });
                                } else {
                                  // TODO: Move file to another folder
                                  // eslint-disable-next-line no-alert
                                  notificationWithIcon('warning', 'Thông báo', 'Tập tin này không thể chỉnh sửa !');
                                }
                              }}
                            />
                          </Tooltip>
                          <Popconfirm
                            title='Bạn có muốn xóa tập tin này không?'
                            onConfirm={async () => {
                              // DELETE
                              await remove('Attachments', id, 'SHARE');
                              // DELETE FILENAME IN FOLDERS
                              // await deleteFile('Folders', selectedFolderId, fileName, 'CLASSES', 'SACHSO');
                              setRefresh(new Date());
                            }}
                            okText='Xác nhận'
                            cancelText='Không'
                          >
                            <Tooltip title='Xóa tập tin' placement='bottom'>
                              <Button key='delete-file' shape='circle' type='dashed' icon={<DeleteOutlined />} danger />
                            </Tooltip>
                          </Popconfirm>
                        </Space>
                      </div>
                    </TeacherContainer>
                  </div>
                ),
              }}
            />
          </div>
        </Col>
      </Row>

      {modalVisible && (
        <Modal
          width='95%'
          style={{ marginTop: 24 }}
          bodyStyle={{ padding: '10px 24px' }}
          centered
          visible={modalVisible}
          title='LIVE WORKSHEET'
          onCancel={() => {
            setModalVisible(false);
            setRefresh(new Date());
            setWorksheetFile(null);
          }}
          footer={<Footer onSubmit={() => refSubmit.current.submit()} tryAgain={() => refSubmit.current.tryAgain()} footerMode={footerMode} setFooterMode={setFooterMode} />}
        >
          {/* <div style={{ height: '80vh' }}>{fileType === 'worksheet' && <CanvasToolPage entityId={selectedFolderId} worksheetFile={worksheetFile} />}</div> */}
          <div style={{ height: '80vh' }}>
            {(() => {
              switch (true) {
                case fileType !== 'worksheet': {
                  return null;
                }
                case footerMode === footerKey.CREATE: {
                  return <CanvasToolPage idCurrent='' entityId={selectedFolderId} worksheetFile={null} teacherId={loggedInUser.userId} onUpdateImage={(id) => openEditor(id, 1000)} />;
                }
                case footerMode === footerKey.EDIT: {
                  return <CanvasToolPage idCurrent={idCurrent} entityId={selectedFolderId} worksheetFile={null} teacherId={loggedInUser.userId} onUpdateImage={(id) => openEditor(id, 1000)} />;
                }
                case footerMode === footerKey.PREVIEW: {
                  return <ExcercisePage file={null} refSubmit={refSubmit} idCurrent={idCurrent} isTeacher />;
                }
                default:
                  break;
              }
            })()}
          </div>
        </Modal>
      )}

      {progressModalVisible && (
        <Modal
          width='95%'
          style={{ marginTop: 24 }}
          centered
          className='progressModal'
          visible={progressModalVisible}
          title={handleChangeTitle(openClassesOrSubjects)}
          onCancel={() => {
            setProgressModalVisible(false);
            setRefresh(new Date());
            setOpenClassesOrSubjects(false);
            setOpenListTopics(false);
          }}
          footer={
            <Button onClick={openListTopics ? () => setOpenListTopics(false) : handleMoveToClasses} type='primary' icon={<LeftOutlined />}>
              Quay lại
            </Button>
          }
        >
          {openClassesOrSubjects ? (
            <ListUnits
              classFields={classFields}
              openListTopics={openListTopics}
              onClick={(id) => {
                setNumberUnit(id); // Unit được chọn số mấy
                setOpenListTopics(true); // Chuyển đổi state ListUnits và ListTopics
              }}
            />
          ) : (
            <ListClasses onMoveToSubjects={handleMoveToSubjects} />
          )}
        </Modal>
      )}

      {previewExercise && (
        <Modal
          width='95%'
          style={{ marginTop: 24 }}
          centered
          visible={previewExercise}
          className='workshetModal'
          title='BÀI TẬP LIVE WORKSHEET'
          onCancel={() => {
            setPreviewExercise(false);
          }}
          footer={loggedInUser?.id && !refSubmit.current.isCompleted ? <Footer onSubmit={() => refSubmit.current.submit()} tryAgain={() => refSubmit.current.tryAgain()} footerMode={footerKey.VIEW} setFooterMode={setFooterMode} /> : null}
        >
          <div style={{ height: 'calc(80vh - 44px)' }}>{previewExercise && <ExcercisePage file={file} studentId={loggedInUser?.id} isCompleted={false} isTeacher refSubmit={refSubmit} />}</div>
        </Modal>
      )}

      {exerciseModalVisible && <ExerciseForStudent exerciseModalVisible={exerciseModalVisible} setExerciseModalVisible={setExerciseModalVisible} selectedFolderId={selectedFolderId} worksheetFile={worksheetFile} />}
    </div>
  );
};

export default withAuthenticator(Folders);
